import { Component, OnInit, inject } from '@angular/core';
import { SeverityViewService } from 'src/app/services/severity-view.service';
import { ActivatedRoute } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { forkJoin, timer, Subscription, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import dayjs from 'dayjs';
import { ShowNavBarService } from 'src/app/services/show-nav-bar.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-shopfloor-top-three',
  imports: [NgFor, NgIf],
  templateUrl: './shopfloor-top-three.component.html',
  styleUrl: './shopfloor-top-three.component.scss',
  standalone: true
})


export class ShopfloorTopThreeComponent implements OnInit {
  //Current Shift
  //Severity views Critical and Major
  protected svcSeverity = inject(SeverityViewService);
  protected svcShowNavBar = inject(ShowNavBarService);
  protected svcLoading = inject(LoadingService);

  //retrieve data every 5 minutes
  private topThreeSubscription: Subscription = new Subscription();

  notCurrentShift: string = "False";
  noIssues: boolean = false;
  isLoading: boolean = false;
  
  
  plant: string = '';
  line: string = '';

  topIssues: any[] = [];
  topThree: any[] = [];

  imageSrc: SafeUrl | undefined;

  today = dayjs();
  weekStart = dayjs().subtract(7,'day');

  

  constructor(private route: ActivatedRoute,
    private sanitizer : DomSanitizer
  ){
  }
  ngOnInit(): void {
    this.plant = this.route.snapshot.paramMap.get('plant') ?? '';
    this.line = this.route.snapshot.paramMap.get('line') ?? '';

    //hide nav bar
    this.svcShowNavBar.setShowNavBar(false);

    const fiveMinutesMs = 5 * 60 * 1000; // 300,000 ms
    this.topThreeSubscription = timer(0, fiveMinutesMs).subscribe(() => {
      this.getTopThree();
    });
  }

  ngOnDestroy(){
    if(this.topThreeSubscription) this.topThreeSubscription.unsubscribe();
  }

  getTopThree(){
    this.svcLoading.show();
    console.debug('Getting top three issues.')
    let fromDateString = this.weekStart.format('YYYY-MM-DD');
    let toDateString = this.today.format('YYYY-MM-DD');

    let criticalData$ = this.svcSeverity.getDetailData(this.notCurrentShift, fromDateString + ' 00:00:00', toDateString + ' 23:59:59.999', this.plant, this.line, "Critical").pipe(take(1));
    let majorData$ = this.svcSeverity.getDetailData(this.notCurrentShift, fromDateString + ' 00:00:00', toDateString + ' 23:59:59.999', this.plant, this.line, "Major").pipe(take(1));
    let obs: Observable<any>[] = [];
    obs.push(criticalData$);
    obs.push(majorData$);

    forkJoin(obs).subscribe(([criticalResult, majorResult]) => {
      console.log(criticalResult)
      console.log(majorResult)
      const criticalIssues = criticalResult.Body || [];
      const majorIssues = majorResult.Body || [];
  

      this.topIssues = [...criticalIssues, ...majorIssues];
      this.topIssues.sort((a, b) => new Date(b.ResultDateTime).getTime() - new Date(a.ResultDateTime).getTime());

      this.topThree = this.topIssues.slice(0, 3);
      this.noIssues = this.topThree.length === 0;
  
      this.getImages();
    });
  }

  getImages(){
    console.log(this.topThree)
    let base64data: any;
    let pic!:Blob;
    this.topThree.forEach(issue => {
      if (issue.Image1){
        this.svcSeverity.getpic(issue.ResultId, 'Image1', this.plant).subscribe(
          (blob) => {
            console.debug("Received picture")
            pic = blob; // Save the blob to be accessed later
    
            var reader = new FileReader();
            reader.readAsDataURL(blob); 
            reader.onloadend = (out) => {
              console.log(' In the function ')
              base64data = reader.result;
              issue.imageSrc = this.sanitizer.bypassSecurityTrustUrl(base64data);
              
            }          
          },
          (err) => {
            console.error("Error generating picture", err);
            this.isLoading = false;
            this.svcLoading.hide();
        });
      }
    })
    console.log(this.topThree)
    this.svcLoading.hide();
    this.isLoading = false;
  }

}
